export const misc: Record<string, string> = {
	str_loadingdotdotdot: "Loading...",
};
